import React, { useRef } from 'react'
import { IconCategory } from '../../../../../../shared/icon/icon'
import { useThumbnailURL } from '../../../../../../shared/thumbnail-cache/use-thumbnail'

// A result's picture (owner 2026-10-09): the same thumbnail as its card,
// through the same cache (shared/thumbnail-cache: this page's memory, the
// browser's storage, then the network once the row nears the viewport, a few
// at a time), so a list of results costs no more than the grid. The box is
// a fixed 2:1 (the cards' shape) whatever is in it, so nothing moves when a
// picture arrives, and the row never waits for one. Until then -- or with
// none -- a course shows the cards' placeholder and a folder a folder tile.
// Decorative: the name is beside it.
export const SearchThumbnail = ({ asset, folder }) => {
  const ref = useRef(null)
  const url = useThumbnailURL(asset, ref)
  const tile = !url && folder

  return (
    <span ref={ref} className={tile ? 'node-search-thumb node-search-thumb-folder' : 'node-search-thumb'} aria-hidden="true" data-testid="search-thumbnail">
      {tile ? <IconCategory size="lg" /> : <img src={url || '/content_placeholder.png'} alt="" decoding="async" draggable="false" />}
    </span>
  )
}
